export default __webpack_public_path__ + "static/media/030-poker machine.82cc5c11.svg";